import Cookies from "js-cookie";
import { AUTH_TOKEN_COOKIE_NAME } from "../contexts/AuthenticationContext";

export function logout() {
  Cookies.remove(AUTH_TOKEN_COOKIE_NAME);
  window.location.reload();
}
